import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import input from '@mailobj-browser/front/js/events/types/input.js'
import { helpers } from '#components/generics/js/styles.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import append from '@mailobj-browser/front/js/tree/append.js'
import replaceWith from '@mailobj-browser/front/js/tree/replaceWith.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'

const colors = [
  '#993400',
  '#CC66CC',
  '#FF99CB',
  '#C9C9C9',
  '#EB3300',
  '#FECB00',
  '#98CB00',
  '#0099CB'
]

const onClick = object(listener, {
  type: click,
  passive,
  task: (
    button
  ) => {
    const wrapper = closest(`[data-show-xfiles='draw']`, button)

    if (wrapper) {
      colorSet(wrapper, button)
    }
  }
})

const onInput = object(listener, {
  type: input,
  passive,
  task: (
    input
  ) => {
    const { value } = input
    const wrapper = closest(`[data-show-xfiles='draw']`, input)
    const colorTxt = one('[type="hidden"][name="canvas_color_txt"]', wrapper)

    if (wrapper && colorTxt) {
      colorTxt.value = value
    }
  }
})

const colorSet = (wrapper, button) => {
  const { value: newColor } = button
  const colorTxt = one('[type="hidden"][name="canvas_color_txt"]', wrapper)

  if (colorTxt) {
    const { value: oldColor } = colorTxt

    colorTxt.value = newColor

    if (oldColor !== newColor) {
      const colorBkg = one('[type="color"][name="canvas_color_bkg"]', wrapper)

      if (colorBkg) {
        const { style } = button

        button.value = oldColor
        style.setProperty('--ea_icon_fill', oldColor)
        style.setProperty('--ea_button_color_hover', oldColor)
        colorBkg.value = newColor
      }
    }
  }
}

export const colorStore = async (wrapper) => {
  const container = one(`.${helpers.xfiles.elements.xfiles_attach_draw_colors_stored}`, wrapper)
  const colorButton = one(`[type='button']`, container)
  const colorBkg = one('[type="color"][name="canvas_color_bkg"]', wrapper)

  colorButton.removeAttribute('data-contract')
  onInput.listen(colorBkg)

  for (let i = 0; i < colors.length; i++) {
    const colorButtonClone = colorButton.cloneNode(true)
    const { style } = colorButtonClone

    if (i === 0) {
      colorButtonClone.value = colors[0]
      colorButtonClone.name = `${colorButton.name}0`
      style.setProperty('--ea_icon_fill', colors[0])
      style.setProperty('--ea_button_color_hover', colors[0])
      replaceWith(colorButton, colorButtonClone)
    } else {
      colorButtonClone.value = colors[i]
      colorButtonClone.name = `${colorButtonClone.name}${i}`
      style.setProperty('--ea_icon_fill', colors[i])
      style.setProperty('--ea_button_color_hover', colors[i])
      append(container, colorButtonClone)
    }

    onClick.listen(colorButtonClone)
  }
}

export default button => {}
